import type { ChartingLibraryWidgetOptions, CustomTimezoneId } from '../../lib/charting_library';
import { DefaultFavoriteIntervals } from '../misc/constants';
import { getTimezone } from '../misc/helper';
import { overrides, studiesOverrides } from './overrides';

function asCustomTimezoneId(id: string): CustomTimezoneId {
  return id as CustomTimezoneId;
}

export const widgetOptions: Omit<ChartingLibraryWidgetOptions, 'symbol' | 'container' | 'datafeed' | 'interval'> = {
  autosize: true,
  auto_save_delay: 0.1,
  favorites: {
    intervals: DefaultFavoriteIntervals,
    chartTypes: [],
  },
  library_path: '/charting_library/',
  load_last_chart: true,
  locale: 'en',
  theme: 'dark',
  overrides,
  studies_overrides: studiesOverrides,
  study_count_limit: 10,
  time_scale: {
    min_bar_spacing: 2,
  },
  timezone: getTimezone(),
  custom_timezones: [
    {
      // GMT-7
      id: asCustomTimezoneId('Etc/GMT-7'),
      alias: 'America/Phoenix',
      title: 'Etc/GMT-7',
    },
    {
      // GMT-6
      id: asCustomTimezoneId('America/Edmonton'),
      alias: 'America/Mexico_City',
      title: 'Edmonton',
    },
    {
      // GMT-6
      id: asCustomTimezoneId('America/Costa_Rica'),
      alias: 'America/Mexico_City',
      title: 'Costa Rica',
    },
    {
      // GMT-3
      id: asCustomTimezoneId('America/Buenos_Aires'),
      alias: 'America/Argentina/Buenos_Aires',
      title: 'Buenos Aires',
    },
    {
      // GMT+1
      id: asCustomTimezoneId('Africa/Porto-Novo'),
      alias: 'Africa/Casablanca',
      title: 'Porto-Novo',
    },
    {
      // GMT+2
      id: asCustomTimezoneId('Africa/Gaborone'),
      alias: 'Africa/Johannesburg',
      title: 'Gaborone',
    },
    {
      // GMT+2
      id: asCustomTimezoneId('Africa/Lusaka'),
      alias: 'Africa/Johannesburg',
      title: 'Lusaka',
    },
    {
      // GMT+2
      id: asCustomTimezoneId('Europe/Sarajevo'),
      alias: 'Europe/Amsterdam',
      title: 'Sarajevo',
    },
    {
      // GMT+3
      id: asCustomTimezoneId('Africa/Addis_Ababa'),
      alias: 'Asia/Jerusalem',
      title: 'Addis Ababa',
    },
    {
      // GMT+3
      id: asCustomTimezoneId('Asia/Aden'),
      alias: 'Asia/Jerusalem',
      title: 'Aden',
    },
    {
      // GMT+3
      id: asCustomTimezoneId('Asia/Beirut'),
      alias: 'Asia/Jerusalem',
      title: 'Beirut',
    },
    {
      // GMT+3
      id: asCustomTimezoneId('Asia/Damascus'),
      alias: 'Asia/Jerusalem',
      title: 'Damascus',
    },
    {
      // GMT+3
      id: asCustomTimezoneId('Europe/Kiev'),
      alias: 'Asia/Jerusalem',
      title: 'Kiev',
    },
    {
      // GMT+3
      id: asCustomTimezoneId('Europe/Minsk'),
      alias: 'Asia/Jerusalem',
      title: 'Minsk',
    },
    {
      // GMT+4
      id: asCustomTimezoneId('Asia/Tbilisi'),
      alias: 'Asia/Dubai',
      title: 'Tbilisi',
    },
    {
      // GMT+5:30
      id: asCustomTimezoneId('Asia/Calcutta'),
      alias: 'Asia/Colombo',
      title: 'Calcutta',
    },
    {
      // GMT+5:45
      id: asCustomTimezoneId('Asia/Katmandu'),
      alias: 'Asia/Kathmandu',
      title: 'Katmandu',
    },
    {
      // GMT+7
      id: asCustomTimezoneId('Asia/Phnom_penh'),
      alias: 'Asia/Jakarta',
      title: 'Phnom Penh',
    },
    {
      // GMT+7
      id: asCustomTimezoneId('Asia/Saigon'),
      alias: 'Asia/Jakarta',
      title: 'Saigon',
    },
    {
      // GMT+7
      id: asCustomTimezoneId('Asia/Pontianak'),
      alias: 'Asia/Jakarta',
      title: 'Pontianak',
    },
    {
      // GMT+8
      id: asCustomTimezoneId('Asia/Makassar'),
      alias: 'Asia/Taipei',
      title: 'Makassar',
    },
    {
      // GMT+8
      id: asCustomTimezoneId('Asia/Macau'),
      alias: 'Asia/Taipei',
      title: 'Macau',
    },
    {
      // GMT+8
      id: asCustomTimezoneId('Asia/Kuching'),
      alias: 'Asia/Taipei',
      title: 'Kuching',
    },
    {
      // GMT+9
      id: asCustomTimezoneId('Asia/Jayapura'),
      alias: 'Asia/Seoul',
      title: 'Jayapura',
    },
    {
      // GMT+10
      id: asCustomTimezoneId('Australia/Melbourne'),
      alias: 'Australia/Sydney',
      title: 'Melbourne',
    },
  ],
};
